var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7499 13.1252H12.7586L15.8074 10.0764C16.1591 9.72483 16.3568 9.24792 16.3569 8.7506C16.357 8.25328 16.1596 7.77628 15.808 7.42453C15.4564 7.07279 14.9795 6.87512 14.4822 6.875C13.9849 6.87488 13.5079 7.07233 13.1561 7.42391L8.67364 11.9064C7.8546 12.7277 7.39465 13.8403 7.39465 15.0002C7.39465 16.1601 7.8546 17.2726 8.67364 18.0939L13.1561 22.5764C13.5079 22.928 13.9849 23.1254 14.4822 23.1253C14.9795 23.1252 15.4564 22.9275 15.808 22.5758C16.1596 22.224 16.357 21.747 16.3569 21.2497C16.3568 20.7524 16.1591 20.2755 15.8074 19.9239L12.7586 16.8752H23.7499C24.2472 16.8752 24.7241 16.6776 25.0757 16.326C25.4273 15.9744 25.6249 15.4974 25.6249 15.0002C25.6249 14.5029 25.4273 14.026 25.0757 13.6743C24.7241 13.3227 24.2472 13.1252 23.7499 13.1252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowDark);
export default __webpack_public_path__ + "static/media/backArrowDark.25c79dfe071f81ab4a4ce7db5299f77d.svg";
export { ForwardRef as ReactComponent };